var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addWords"},[_c('h1',[_vm._v("建立單字卡")]),_c('FormContainer'),_c('h2',{staticClass:"recent"},[_vm._v("最近添加的單字")]),_c('Cards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }